// noinspection DuplicatedCode

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPostSilance } from "../../../fetchers";
import { useQuery } from "@tanstack/react-query";
import { DynamicTableExtendProcurment } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import debounce from "lodash/debounce";

const PurchaseOrderPage = () => {
  const navigate = useNavigate();

  const [bisnisUnitID, setBisnisUnitID] = useState("U0002");
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [count, setCount] = useState(maxPageGlobal);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const debouncedSetSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchQuery(value);
        setPage(1);
      }, 600),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSetSearch.cancel();
    };
  }, [debouncedSetSearch]);

  const { data: bisnisUnitData } = useQuery({
    queryKey: ["master-bisnis-unit-min"],
    queryFn: () => fetchGet("getMinMasterBisnisUnit"),
    staleTime: 300000,
  });

  const tablePayload = useMemo(() => {
    return {
      search: searchQuery,
      BisnisUnitID: bisnisUnitID,
      Menu: "PurchaseOrder",
    };
  }, [searchQuery, bisnisUnitID]);

  const { data: mutationData } = useQuery({
    queryKey: ["purchase-order-table", tablePayload],
    queryFn: () =>
      fetchPostSilance("Procurement/PurchaseRequisition/table", tablePayload),
    keepPreviousData: true,
    staleTime: 30000,
  });

  useEffect(() => {
    // No pagination - all data returned
    const dataLength = mutationData?.data?.length || 0;
    const totalPage = dataLength > 0 ? 1 : 1;
    setMaxPage(totalPage);

    if (page > totalPage) {
      setPage(totalPage);
    }
  }, [mutationData, page]);

  const header = useMemo(
    () => [
      { name: "Nomor MSR", key: "PurchaseRequisitionID", modifiers: "Text" },
      {
        name: "Nomor Price Comparation",
        key: "PRComparisonID",
        modifiers: "Text",
      },
      { name: "PIC", key: "ALLOCATED", modifiers: "Text" },
      { name: "Bisnis Unit", key: "NamaBisnisUnit", modifiers: "Text" },
      { name: "Tanggal Price Comparation", key: "DatePR", modifiers: "Date" },
      { name: "Pemohon", key: "Requester", modifiers: "Text" },
      { name: "Keterangan", key: "Remarks", modifiers: "Text" },
      { name: "Status", key: "STATUS", modifiers: "Text" },
      { name: "Tipe", key: "Tipe", modifiers: "Text" },
      { name: "Aksi", key: "Edit", modifiers: "Button" },
    ],
    []
  );

  const editOpener = useCallback(
    (detail, purchaseRequisitionID) => {
      navigate("/procurment/transaction/form-purchase-order", {
        state: {
          PRComparisonID: detail,
          PurchaseRequisitionID: purchaseRequisitionID,
        },
      });
    },
    [navigate]
  );

  const kirim = () => {};
  const modalOpener = () => {};
  const handleModal = () => {};

  const filterData = useCallback(
    (value) => {
      // Handle both string value and event object
      const stringValue = typeof value === "string" ? value : (value?.target?.value || "");
      setSearchInput(stringValue);
      debouncedSetSearch(stringValue);
    },
    [debouncedSetSearch]
  );

  const handleUpdatePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleUpdateCount = useCallback((newCount) => {
    const newCountInt = parseInt(newCount, 10);
    const safeCount =
      Number.isNaN(newCountInt) || newCountInt < 1 ? maxPageGlobal : newCountInt;

    setCount(safeCount);
    setPage(1);
  }, []);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col content-center">
                {bisnisUnitData?.data && (
                  <div className={"w-full md:w-1/3 px-3"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Bisnis Unit
                    </label>

                    <Select
                      value={
                        bisnisUnitData.data.find(
                          ({ value }) => value === bisnisUnitID
                        ) || null
                      }
                      name={"BisnisUnitID"}
                      className={
                        "appearance-none block w-full text-gray-700 border border-main-100 outline-none bg-white"
                      }
                      onChange={(text) => {
                        setBisnisUnitID(text.value);
                        setPage(1);
                      }}
                      options={bisnisUnitData.data}
                    />
                  </div>
                )}

                <DynamicTableExtendProcurment
                  types="PurchaseOrder"
                  data={mutationData}
                  header={header}
                  menuController={filterData}
                  Master={false}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"UserPC"}
                  OnClick={modalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                  editor={editOpener}
                  kirim={kirim}
                  value={searchInput}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderPage;
